import { render } from "./Activation2.vue?vue&type=template&id=7790a8cf"
import script from "./Activation2.vue?vue&type=script&lang=js"
export * from "./Activation2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__